import { Badge, IconBox } from "@hightouch/htui";
import {
  IconTile,
  type IconTileTone,
} from "src/pages/context-hub/components/knowledge-list/name-cell";
import {
  DEFINITION_STATUS_ICONS,
  DEFINITION_STATUS_LABELS,
  type DefinitionDisplayStatus,
  definitionStatusColor,
} from "./utils";

const STATUS_BADGE_VARIANTS: Record<
  DefinitionDisplayStatus,
  "warning" | "success"
> = {
  assumed: "warning",
  verified: "success",
  proposed_update: "warning",
};

export const DefinitionStatusIcon = ({
  status,
}: {
  status: DefinitionDisplayStatus;
}) => {
  const Icon = DEFINITION_STATUS_ICONS[status];
  return (
    <IconBox
      color={definitionStatusColor(status)}
      icon={<Icon role="img" aria-label={DEFINITION_STATUS_LABELS[status]} />}
    />
  );
};

export const DefinitionStatusBadge = ({
  status,
  hasIcon = true,
}: {
  status: DefinitionDisplayStatus;
  hasIcon?: boolean;
}) => (
  <Badge
    variant={STATUS_BADGE_VARIANTS[status]}
    svgIcon={hasIcon ? DEFINITION_STATUS_ICONS[status] : undefined}
  >
    {DEFINITION_STATUS_LABELS[status]}
  </Badge>
);

const STATUS_TILE_TONES: Record<DefinitionDisplayStatus, IconTileTone> = {
  assumed: "warning",
  verified: "success",
  proposed_update: "warning",
};

export const DefinitionStatusTile = ({
  status,
  size,
}: {
  status: DefinitionDisplayStatus;
  size?: "sm" | "md";
}) => (
  <IconTile
    icon={DEFINITION_STATUS_ICONS[status]}
    tone={STATUS_TILE_TONES[status]}
    size={size}
  />
);
